import { Injectable } from "@angular/core";
import { Veiculo } from "@tivic-team/manager-ts/dist/fta/entities/veiculo.entity";
import { Pessoa } from "@tivic-team/manager-ts/dist/grl";
import { ConcessaoVeiculo } from "@tivic-team/manager-ts/dist/mob/entities/concessao/concessao-veiculo.entity";
import { ConcessaoVeiculoDTO, ConcessaoVeiculoListDTO } from "app/model/dtos/mob/concessao-veiculo.dto";
import { VeiculoEquipamentoDTO } from "app/model/dtos/mob/veiculo-equipamento.dto";
import { ConcessaoVeiculoController } from '../../controllers/mob/concessao-veiculo.controller';
import { RelatorioConessaoVeiculoListDTO } from '../../model/dtos/mob/relatorio-concessao-veiculo.dto';
import { ApiService } from "../api-service.interface";
import { LoaderService } from "../loader.service";
import { ConcessaoVeiculoSearch } from './concessao-veiculo.search';


@Injectable({
  providedIn: "root",
})
export class ConcessaoVeiculoService implements ApiService<ConcessaoVeiculoDTO> {
  
  constructor(
    private _concessaoVeiculoController: ConcessaoVeiculoController,
    private _loaderService: LoaderService
  ) { }
  create(entity: ConcessaoVeiculoDTO): Promise<ConcessaoVeiculoDTO> {
    throw new Error("Method not implemented.");
  }
  update(entity: ConcessaoVeiculoDTO): Promise<ConcessaoVeiculoDTO> {
    throw new Error("Method not implemented.");
  }

  findConcessaoVeiculos(search?:ConcessaoVeiculoSearch):Promise<Array<ConcessaoVeiculoDTO>>{
    this._loaderService.show();
    return this._concessaoVeiculoController.findConcessaoVeiculos(search && search.getFilters() || null).finally(() => this._loaderService.hide());
  }

  find(search?:ConcessaoVeiculoSearch):Promise<Array<ConcessaoVeiculoDTO>>{
    this._loaderService.show();
    return this._concessaoVeiculoController.find(search && search.getFilters() || null).finally(() => this._loaderService.hide());
  }

  findConcessaoVeiculo(search?: ConcessaoVeiculoSearch): Promise<ConcessaoVeiculoListDTO> {
    this._loaderService.show();
    return this._concessaoVeiculoController.findConcessaoVeiculo(search && search.getFilters() || null).finally(() => this._loaderService.hide());
  }

  async save(concessaoVeiculoDTO: ConcessaoVeiculoDTO): Promise<ConcessaoVeiculoDTO> {
    this._loaderService.show();
    if (concessaoVeiculoDTO.cdConcessaoVeiculo && concessaoVeiculoDTO.cdConcessaoVeiculo > 0) {
      return this._concessaoVeiculoController.updateVeiculo(concessaoVeiculoDTO).finally(() => this._loaderService.hide());
    } else {
      return this._concessaoVeiculoController.createVeiculo(concessaoVeiculoDTO).finally(() => this._loaderService.hide());
    }
  }

  async desvincular(concessaoVeiculoDTO: ConcessaoVeiculoDTO): Promise<ConcessaoVeiculoDTO> {
    this._loaderService.show();
    return this._concessaoVeiculoController.desvincular(concessaoVeiculoDTO).finally(() => this._loaderService.hide());
  }


  async getVeiculoConcessao(cdConcessaoVeiculo: number): Promise<ConcessaoVeiculoDTO> {
    this._loaderService.show();
    return this._concessaoVeiculoController
      .getVeiculoConcessao(cdConcessaoVeiculo)
      .finally(() => this._loaderService.hide());
  }

  async get(cdConcessaoVeiculo: number): Promise<ConcessaoVeiculoDTO> {
    this._loaderService.show();
    return this._concessaoVeiculoController.get(cdConcessaoVeiculo).finally(() => this._loaderService.hide());
  }

  async getEquipamentosByConcessaoVeiculo(cdConcessaoVeiculo: number): Promise<Array<VeiculoEquipamentoDTO>> {
    this._loaderService.show();
    return this._concessaoVeiculoController
      .getEquipamentosByConcessaoVeiculo(cdConcessaoVeiculo)
      .finally(() => this._loaderService.hide());
  }

  async getConcessionario(nrPrefixo: number): Promise<Pessoa> {
    this._loaderService.show();
    return this._concessaoVeiculoController.getConcessionario(nrPrefixo).finally(() => this._loaderService.hide());
  }

  async getConcessao(nrPrefixo: number): Promise<ConcessaoVeiculo> {
    this._loaderService.show();
    return this._concessaoVeiculoController.getConcessao(nrPrefixo).finally(() => this._loaderService.hide());
  }

  async getVeiculo(cdConcessaoVeiculo: number): Promise<Veiculo> {
    this._loaderService.show();
    return this._concessaoVeiculoController.getVeiculo(cdConcessaoVeiculo).finally(() => this._loaderService.hide());
  }

  async getVeiculoByPlaca(nrPlaca: String): Promise<ConcessaoVeiculoDTO> {
    this._loaderService.show();
    return this._concessaoVeiculoController.getVeiculoByPlaca(nrPlaca).finally(() => this._loaderService.hide());
  }

  async getVeiculosByConcessao(cdConcessao: number, concessaoVeiculoSearh?: ConcessaoVeiculoSearch): Promise<ConcessaoVeiculoDTO[]> {
    this._loaderService.show();
    return this._concessaoVeiculoController.getVeiculosByConcessao(cdConcessao, concessaoVeiculoSearh && concessaoVeiculoSearh.getFilters()).finally(() => this._loaderService.hide());
  }

  async getConcessaoVeiculo(concessaoVeiculoSearch?: ConcessaoVeiculoSearch): Promise<ConcessaoVeiculoListDTO> {
    this._loaderService.show();
    return this._concessaoVeiculoController.findConcessaoVeiculo((concessaoVeiculoSearch && concessaoVeiculoSearch.getFilters()) || null).finally(() => this._loaderService.hide());
  }

  async relatorioConcessaoVeiculo(concessaoVeiculoSearch?: ConcessaoVeiculoSearch): Promise<RelatorioConessaoVeiculoListDTO> {
    this._loaderService.show();
    return this._concessaoVeiculoController.relatorioConcessaoVeiculo((concessaoVeiculoSearch && concessaoVeiculoSearch.getFilters()) || null).finally(() => this._loaderService.hide());
  }

  async getRelatorioConcessaoVeiculo(concessaoVeiculoSearch?: ConcessaoVeiculoSearch): Promise<Blob> {
    this._loaderService.show();
    return this._concessaoVeiculoController.getRelatorioConcessaoVeiculo((concessaoVeiculoSearch && concessaoVeiculoSearch.getFilters()) || null).finally(() => this._loaderService.hide());
  }
  
  async findVeiculos(concessaoVeiculoSearch?: ConcessaoVeiculoSearch): Promise<Array<ConcessaoVeiculoDTO>> {
    this._loaderService.show();
    return this._concessaoVeiculoController.findVeiculos((concessaoVeiculoSearch && concessaoVeiculoSearch.getFilters()) || null).finally(() => this._loaderService.hide());
  }

  findVeiculosByConcessao(concessaoVeiculoSearch?: ConcessaoVeiculoSearch): Promise<Array<ConcessaoVeiculo>> {
    this._loaderService.show();
    return this._concessaoVeiculoController.findVeiculosByConcessao((concessaoVeiculoSearch && concessaoVeiculoSearch.getFilters()) || null).finally(() => this._loaderService.hide());
  }
}
